import { Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core"
import { Close } from "@material-ui/icons";
import React, { useEffect } from "react"
import { useSelector } from "react-redux";

import { envName } from "../../../utils/config";

interface PreviewModalProps {
    open: boolean;
    onClose?: () => void;
    scenario: any;
    sceneId?: string;
}

export const PreviewModal = ({ open, onClose, scenario, sceneId }: PreviewModalProps) => {
    const defaultAccountId = useSelector((state) => (state as any).session.defaultAccountId);

    const initPlayer = () => {
        (window as any).QplayerLoader.killInteractivePlayer?.();
        if (
            (window as any).QplayerLoader?.initiateInteractivePlayer &&
            typeof (window as any).QplayerLoader?.initiateInteractivePlayer === 'function'
        ) {
            (window as any).QplayerLoader?.initiateInteractivePlayer();
        }
    };

    useEffect(() => {
        if (open) {
            setTimeout(initPlayer, 0);
        } else {
            (window as any).QplayerLoader.killInteractivePlayer?.();
        }

        return () => (window as any).QplayerLoader.killInteractivePlayer?.();
    }, [open]);

    return <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={open}
        onClose={onClose}
        className={onClose ? 'preview-interact-modal' : undefined}
    >
        <DialogContent style={{ padding: '0', margin: '0', overflow: 'hidden' }}>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: '100%', width: '100%' }}>
                <div
                    style={{ position: 'absolute', top: 0, left: 0 }}
                    data-qplayer-thumbnail-width="100%"
                    data-qplayer-thumbnail-height="100%"
                    data-qplayer-id={'interact-preview'}
                    data-qplayer-scenario-id={scenario?.id}
                    data-qplayer-scene-id={sceneId}
                    data-qplayer-account-id={defaultAccountId}
                    data-qplayer-preset-id={'Interactive'}
                    data-qplayer-inline={'on'}
                    data-qplayer-analytics={'off'}
                    data-qplayer-title={scenario?.metadata?.title || 'Interactive Preview'}
                    data-qplayer-alpha={envName === 'alpha' || envName === 'development' ? 'true' : 'false'}
                    data-qplayer-beta={envName === 'beta' ? 'true' : 'false'}
                />
            </div>
        </DialogContent>

        {onClose && <DialogTitle id="alert-dialog-title" style={{ position: 'absolute', right: '0', top: '0' }}>
            <IconButton
                onClick={onClose}
                title='Close'
            >
                <Close fontSize="large" htmlColor="#fff" />
            </IconButton>
        </DialogTitle>}
    </Dialog>
}